import React, { useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Lenis from "lenis";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import AllProjects from "../components/projects/allProjects";

import INFO from "../data/user";
import SEO from "../data/seo";
import "./styles/projects.css";

gsap.registerPlugin(ScrollTrigger);

const Projects = () => {
	const headRef = useRef(null);
	const listRef = useRef(null);

	useEffect(() => {
		window.scrollTo(0, 0);

		const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
		lenis.on("scroll", ScrollTrigger.update);
		const raf = (t) => { lenis.raf(t); requestAnimationFrame(raf); };
		requestAnimationFrame(raf);

		gsap.fromTo(headRef.current,
			{ y: 40, opacity: 0 },
			{ y: 0, opacity: 1, duration: 0.9, ease: "power3.out" }
		);
		gsap.fromTo(listRef.current,
			{ y: 50, opacity: 0 },
			{ y: 0, opacity: 1, duration: 0.9, ease: "power3.out", delay: 0.2 }
		);

		return () => { lenis.destroy(); ScrollTrigger.getAll().forEach(t => t.kill()); };
	}, []);

	const currentSEO = SEO.find((item) => item.page === "projects");

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Projects | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta name="keywords" content={currentSEO.keywords.join(", ")} />
			</Helmet>

			<div className="page-content">
				<NavBar active="projects" />
				<div className="content-wrapper">
					<div className="projects-container">
						<div ref={headRef}>
							<div className="page-section-label">Projects</div>
							<h1 className="title projects-title">Things I've Built.</h1>
							<p className="subtitle projects-subtitle">
								A collection of real-world projects — web platforms, mobile apps, CRMs, and e-commerce solutions built across UAE and beyond.
							</p>
						</div>
						<div ref={listRef} className="projects-list">
							<AllProjects />
						</div>
					</div>
					<div className="page-footer"><Footer /></div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Projects;
